import React from 'react';
import { Content, Button, Text, Flex } from '@leverege/ui-elements';
import S from './Style.css';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
function ResetFail(props) {
  const {
    error,
    zonesDeleted,
    vehiclesDeleted,
    onClose
  } = props;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(Content.Area, {
      variant: "dialogBody",
      layout: "flex:colM",
      className: S.container,
      children: [/*#__PURE__*/_jsxs(Flex, {
        variant: "colS",
        align: "center",
        children: [/*#__PURE__*/_jsx("img", {
          height: "48px",
          width: "48px",
          alt: "reset failed",
          src: "https://recovr-ui-assets.storage.googleapis.com/reset-fail.svg"
        }), /*#__PURE__*/_jsx(Text, {
          variant: "subtitle",
          children: "Reset Failed"
        })]
      }), /*#__PURE__*/_jsxs(Flex, {
        variant: "colS",
        align: "center",
        children: [/*#__PURE__*/_jsxs(Text, {
          variant: "body",
          children: ["Failed with error: ", error?.message || 'network error']
        }), /*#__PURE__*/_jsxs(Text, {
          variant: "body",
          children: ["Before failure, ", zonesDeleted, " zone(s) and ", vehiclesDeleted, " vehicle(s) were deleted."]
        })]
      })]
    }), /*#__PURE__*/_jsx(Content.Footer, {
      variant: "dialogFooter",
      layout: "flex:rowMEnd",
      children: /*#__PURE__*/_jsx(Button, {
        onClick: onClose,
        variant: "primary",
        children: "Done"
      })
    })]
  });
}
export default ResetFail;